import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=dc99eeca"
import script from "./DialogConfirmation.vue?vue&type=script&lang=ts"
export * from "./DialogConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports